// /* Oath — Statement Banner deck-of-cards stack-and-settle entrance.
//    S66 (2026-06-10): the block images "come up as cards on top of the background,
//    one on top of the other, like getting stacked as a deck of cards."

//    S82 (2026-06-16, Unnati slide 9 "the animation isn't working still"): the S66
//    version was scroll-SCRUBBED — progress tied to scroll position, so if the user
//    landed on the section without scrolling THROUGH it (or scrolled past fast), the
//    cards were already settled and the animation was never seen. Per her ask — "this
//    should happen automatically as soon as the user scrolls to this section" — switch
//    to an IntersectionObserver ONE-SHOT auto-play driven by TIME, not scroll. Same
//    rise + fade + stagger motion; it just plays itself once on entry.

//    Cross-browser plain JS (CSS scroll-timeline isn't in Safari; Oath is 95% iOS).
//    Resting rotation comes from each card's --oath-card-rot CSS var.
//    Reduced-motion: cards show settled, JS no-ops. */
// (function () {
//   var ENTRY = 90;            // px each card rises from
//   var DURATION = 1300;       // ms total play
//   var STAGGER_SPAN = 0.55;   // fraction of the play over which cards begin, staggered
//   var CARD_SPAN = 0.45;      // fraction of the play each card takes to settle

//   function settle(cards, rests) {
//     for (var i = 0; i < cards.length; i++) {
//       cards[i].style.transform = 'translateY(0px) rotate(' + rests[i] + ')';
//       cards[i].style.opacity = '1';
//     }
//   }

//   function play(cards, rests, start) {
//     var N = cards.length;
//     function frame(now) {
//       var p = (now - start) / DURATION;
//       if (p < 0) p = 0; else if (p > 1) p = 1;
//       for (var i = 0; i < N; i++) {
//         var s = (i / N) * STAGGER_SPAN;
//         var cp = (p - s) / CARD_SPAN;
//         if (cp < 0) cp = 0; else if (cp > 1) cp = 1;
//         var e = 1 - Math.pow(1 - cp, 3);   // ease-out cubic
//         cards[i].style.transform = 'translateY(' + ((1 - e) * ENTRY).toFixed(1) + 'px) rotate(' + rests[i] + ')';
//         cards[i].style.opacity = e.toFixed(3);
//       }
//       if (p < 1) window.requestAnimationFrame(frame);
//       else settle(cards, rests);
//     }
//     window.requestAnimationFrame(frame);
//   }

//   function init(section) {
//     if (!section || section.dataset.stackInit === '1') return;
//     var cards = Array.prototype.slice.call(
//       section.querySelectorAll('.oath-statement-banner__image')
//     );
//     if (!cards.length) return;
//     section.dataset.stackInit = '1';

//     var rests = cards.map(function (c) {
//       return (getComputedStyle(c).getPropertyValue('--oath-card-rot') || '0deg').trim();
//     });

//     if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//       settle(cards, rests); // show the settled deck, no entrance
//       return;
//     }

//     // Initial hidden/lifted state so the play has somewhere to come from.
//     for (var i = 0; i < cards.length; i++) {
//       cards[i].style.transform = 'translateY(' + ENTRY + 'px) rotate(' + rests[i] + ')';
//       cards[i].style.opacity = '0';
//     }

//     if (!('IntersectionObserver' in window)) {
//       play(cards, rests, performance.now());
//       return;
//     }
//     var io = new IntersectionObserver(function (entries, obs) {
//       for (var j = 0; j < entries.length; j++) {
//         if (entries[j].isIntersecting) {
//           obs.disconnect();            // one-shot
//           play(cards, rests, performance.now());
//           break;
//         }
//       }
//     }, { threshold: 0.25 });
//     io.observe(section);
//   }

//   function boot() {
//     var sections = document.querySelectorAll('.oath-statement-banner');
//     for (var i = 0; i < sections.length; i++) init(sections[i]);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', boot);
//   } else {
//     boot();
//   }
//   // Theme editor: re-init when the section is re-rendered.
//   document.addEventListener('shopify:section:load', function (e) {
//     var s = e.target && e.target.querySelector
//       ? e.target.querySelector('.oath-statement-banner')
//       : null;
//     if (s) { s.dataset.stackInit = ''; init(s); }
//   });
// })();

/*
 * Oath — Statement Banner: Stack Up entrance + continuous cycle
 * assets/oath-statement-stack.js
 *
 * Behaviour:
 *   1. ENTRANCE (scroll-driven): when the section scrolls into view the cards
 *      rise from below + fade in, staggered one-by-one, settling into the deck.
 *   2. CYCLE (continuous loop): once settled, the deck keeps shuffling — the
 *      front card fades + lifts away, the next card takes the top, and the
 *      outgoing card drops to the back. Loops indefinitely. Because every card
 *      carries its own resting rotation (owned by CSS), the top angle shifts a
 *      touch on each swap, matching the reference video.
 *
 * Design note — "composed on each card's resting geometry":
 *   The resting deck (each card's translate / rotate / skew) is owned entirely
 *   by CSS. All transform motion here uses the Web Animations API with
 *   `composite: 'add'`, so the rise/lift is LAYERED ON TOP of the resting
 *   transform and resolves to 0 at rest. The script never reads or clobbers
 *   the fan; it only controls opacity and z-index ordering for the cycle.
 *
 * Progressive enhancement:
 *   - prefers-reduced-motion  -> no motion / no cycle, cards shown as authored
 *   - no Web Animations API   -> cards shown as authored
 *   - no IntersectionObserver -> entrance runs immediately on init
 *   - tab hidden              -> cycle pauses, resumes when visible
 *
 * Per-section tuning via data-* attributes on the <section> (all optional):
 *   ENTRANCE
 *     data-oath-stack-distance        px each card rises from      (default 60)
 *     data-oath-stack-duration        ms per card                  (default 900)
 *     data-oath-stack-stagger         ms between cards             (default 220)
 *   CYCLE
 *     data-oath-stack-loop            "false" to disable cycling   (default on)
 *     data-oath-stack-interval        ms each card holds on top    (default 2800)
 *     data-oath-stack-cycle-duration  ms of the swap transition    (default 1000)
 *     data-oath-stack-cycle-lift      px the outgoing card lifts    (default 26)
 *   SHARED
 *     data-oath-stack-easing          CSS easing string            (default settle ease-out)
 *     data-oath-stack-threshold       IntersectionObserver ratio   (default 0.25)
 *     data-oath-stack-root-margin     IntersectionObserver margin  (default 0px 0px -10% 0px)
 */
/*
 * Oath — Statement Banner: Stack Up entrance + continuous cycle
 * assets/oath-statement-stack.js
 *
 * Two visual modes (set data-oath-stack-solo on the <section>):
 *
 *   STACK mode (default, solo = false)
 *     Entrance: cards rise + fade in, staggered, settling into the deck.
 *     Cycle:    front card fades/lifts away to REVEAL the card beneath; the
 *               outgoing card drops to the back. The whole fanned deck stays
 *               visible (you see the edges of cards underneath).
 *
 *   SOLO mode (solo = true)  ← only ONE image visible at a time
 *     Entrance: only the front card fades up; the rest stay hidden.
 *     Cycle:    CROSSFADE — current image fades out while the next fades in,
 *               everything else stays at opacity 0. A clean slideshow.
 *
 * Design note — "composed on each card's resting geometry":
 *   The resting deck (each card's translate / rotate / skew) is owned by CSS.
 *   All transform motion here uses the Web Animations API with
 *   `composite: 'add'`, so any rise/lift layers ON TOP of the resting
 *   transform and resolves to 0 at rest. The script only controls opacity and
 *   z-index ordering; it never reads or clobbers the fan.
 *
 * Progressive enhancement:
 *   - prefers-reduced-motion  -> no motion / no cycle (STACK: deck as authored;
 *                                SOLO: just the first image shown)
 *   - no Web Animations API   -> cards shown as authored
 *   - no IntersectionObserver -> entrance runs immediately on init
 *   - tab hidden              -> cycle pauses, resumes when visible
 *
 * Per-section tuning via data-* attributes on the <section> (all optional):
 *   MODE
 *     data-oath-stack-solo            "true" = one image at a time (default off)
 *   ENTRANCE
 *     data-oath-stack-distance        px each card rises from      (default 60)
 *     data-oath-stack-duration        ms per card                  (default 900)
 *     data-oath-stack-stagger         ms between cards (stack mode) (default 220)
 *   CYCLE
 *     data-oath-stack-loop            "false" to disable cycling   (default on)
 *     data-oath-stack-interval        ms each image holds on top   (default 2800)
 *     data-oath-stack-cycle-duration  ms of the swap transition    (default 1000)
 *     data-oath-stack-cycle-lift      px the outgoing card lifts    (default 26; 0 = pure fade)
 *   SHARED
 *     data-oath-stack-easing          CSS easing string            (default smooth ease-out)
 *     data-oath-stack-threshold       IntersectionObserver ratio   (default 0.25)
 *     data-oath-stack-root-margin     IntersectionObserver margin  (default 0px 0px -10% 0px)
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-oath-section="statement-banner"]';
  var CARD_SELECTOR = '.oath-statement-banner__image';

  var DEFAULTS = {
    solo: false,        // false = stack/reveal deck, true = one image at a time
    // entrance
    distance: 60,
    duration: 900,
    stagger: 220,
    // cycle
    loop: true,
    interval: 2800,
    cycleDuration: 1000,
    cycleLift: 26,
    // shared
    easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
    threshold: 0.25,
    rootMargin: '0px 0px -10% 0px'
  };

  var prefersReduced =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var supportsWAAPI =
    typeof Element !== 'undefined' &&
    typeof Element.prototype.animate === 'function';

  function num(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function bool(value, fallback) {
    if (value == null) return fallback;
    return value !== 'false';
  }

  function readConfig(section) {
    var d = section.dataset;
    return {
      solo: bool(d.oathStackSolo, DEFAULTS.solo),
      distance: num(d.oathStackDistance, DEFAULTS.distance),
      duration: num(d.oathStackDuration, DEFAULTS.duration),
      stagger: num(d.oathStackStagger, DEFAULTS.stagger),
      loop: bool(d.oathStackLoop, DEFAULTS.loop),
      interval: num(d.oathStackInterval, DEFAULTS.interval),
      cycleDuration: num(d.oathStackCycleDuration, DEFAULTS.cycleDuration),
      cycleLift: num(d.oathStackCycleLift, DEFAULTS.cycleLift),
      easing: d.oathStackEasing || DEFAULTS.easing,
      threshold: num(d.oathStackThreshold, DEFAULTS.threshold),
      rootMargin: d.oathStackRootMargin || DEFAULTS.rootMargin
    };
  }

  function cfg(section) {
    if (!section.__oathStackCfg) section.__oathStackCfg = readConfig(section);
    return section.__oathStackCfg;
  }

  function getCards(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll(CARD_SELECTOR)
    );
  }

  function hide(cards) {
    cards.forEach(function (card) {
      card.style.opacity = '0';
      card.style.willChange = 'transform, opacity';
    });
  }

  function show(cards) {
    cards.forEach(function (card) {
      card.style.opacity = '';
      card.style.willChange = '';
    });
  }

  /* ---- entrance ------------------------------------------------------- */

  function revealCard(card, index, conf) {
    var delay = index * conf.stagger;

    card.animate(
      [{ opacity: 0 }, { opacity: 1 }],
      { duration: conf.duration, delay: delay, easing: conf.easing, fill: 'both' }
    );

    var lift = card.animate(
      [
        { transform: 'translateY(' + conf.distance + 'px)' },
        { transform: 'translateY(0px)' }
      ],
      {
        duration: conf.duration,
        delay: delay,
        easing: conf.easing,
        fill: 'both',
        composite: 'add'
      }
    );

    lift.addEventListener('finish', function () {
      card.style.willChange = '';
    });
  }

  /* ---- STACK cycle: fade front away to reveal the card beneath -------- */

  function startStackCycle(section, cards, conf) {
    if (cards.length < 2) return function () {};

    var base = cards.length;
    var order = cards.slice();
    applyZ();

    var timer = null;
    var stopped = false;

    function applyZ() {
      order.forEach(function (card, i) { card.style.zIndex = String(base - i); });
    }
    function schedule() { timer = window.setTimeout(tick, conf.interval); }

    function tick() {
      if (stopped) return;
      if (document.hidden) { schedule(); return; }

      var front = order[0];
      front.style.willChange = 'transform, opacity';

      var fade = front.animate(
        [{ opacity: 1 }, { opacity: 0 }],
        { duration: conf.cycleDuration, easing: conf.easing, fill: 'forwards' }
      );
      var lift = conf.cycleLift
        ? front.animate(
            [{ transform: 'translateY(0px)' },
             { transform: 'translateY(-' + conf.cycleLift + 'px)' }],
            { duration: conf.cycleDuration, easing: conf.easing,
              fill: 'forwards', composite: 'add' }
          )
        : null;

      fade.addEventListener('finish', function () {
        if (lift) lift.cancel();
        fade.cancel();
        order.push(order.shift());
        applyZ();                  // send outgoing to the back first...
        front.style.opacity = '';  // ...then restore it (now hidden behind)
        front.style.willChange = '';
      });

      schedule();
    }

    schedule();
    return function stop() { stopped = true; if (timer) window.clearTimeout(timer); };
  }

  /* ---- SOLO cycle: crossfade, only one image visible ----------------- */

  function startSoloCycle(section, cards, conf) {
    if (cards.length < 2) return function () {};

    var base = cards.length;
    var order = cards.slice();
    order.forEach(function (card, i) {
      card.style.zIndex = String(base - i);
      if (i !== 0) card.style.opacity = '0'; // keep all but the front hidden
    });

    var timer = null;
    var stopped = false;

    function schedule() { timer = window.setTimeout(tick, conf.interval); }

    function tick() {
      if (stopped) return;
      if (document.hidden) { schedule(); return; }

      var current = order[0];
      var next = order[1];
      current.style.willChange = 'transform, opacity';
      next.style.willChange = 'opacity';

      var out = current.animate(
        [{ opacity: 1 }, { opacity: 0 }],
        { duration: conf.cycleDuration, easing: conf.easing, fill: 'forwards' }
      );
      var inc = next.animate(
        [{ opacity: 0 }, { opacity: 1 }],
        { duration: conf.cycleDuration, easing: conf.easing, fill: 'forwards' }
      );
      var lift = conf.cycleLift
        ? current.animate(
            [{ transform: 'translateY(0px)' },
             { transform: 'translateY(-' + conf.cycleLift + 'px)' }],
            { duration: conf.cycleDuration, easing: conf.easing,
              fill: 'forwards', composite: 'add' }
          )
        : null;

      out.addEventListener('finish', function () {
        if (lift) lift.cancel();
        out.cancel();
        inc.cancel();
        current.style.opacity = '0'; // outgoing fully hidden
        next.style.opacity = '';     // incoming stays visible (CSS default = 1)
        current.style.willChange = '';
        next.style.willChange = '';
        order.push(order.shift());
        order.forEach(function (card, i) { card.style.zIndex = String(base - i); });
      });

      schedule();
    }

    schedule();
    return function stop() { stopped = true; if (timer) window.clearTimeout(timer); };
  }

  /* ---- orchestration -------------------------------------------------- */

  function play(section) {
    if (section.dataset.oathStackDone === 'true') return;
    section.dataset.oathStackDone = 'true';

    var cards = getCards(section);
    if (!cards.length) return;

    var conf = cfg(section);

    if (conf.solo) {
      // entrance: only the front image fades up; the rest stay hidden
      cards[0].style.opacity = '';
      revealCard(cards[0], 0, conf);
      for (var i = 1; i < cards.length; i++) cards[i].style.willChange = '';

      if (conf.loop && cards.length > 1) {
        var soloEnd = conf.duration; // single-card entrance
        section.__oathStackStartTimer = window.setTimeout(function () {
          section.__oathStackStop = startSoloCycle(section, cards, conf);
        }, soloEnd + conf.interval);
      }
      return;
    }

    // stack mode: staggered entrance for the whole deck
    cards.forEach(function (card, idx) {
      card.style.opacity = '';
      revealCard(card, idx, conf);
    });

    if (conf.loop && cards.length > 1) {
      var entranceEnd = (cards.length - 1) * conf.stagger + conf.duration;
      section.__oathStackStartTimer = window.setTimeout(function () {
        section.__oathStackStop = startStackCycle(section, cards, conf);
      }, entranceEnd + conf.interval);
    }
  }

  function init(section) {
    if (!section || section.dataset.oathStackInit === 'true') return;
    section.dataset.oathStackInit = 'true';

    var cards = getCards(section);
    if (!cards.length) return;

    var conf = cfg(section);

    if (prefersReduced || !supportsWAAPI) {
      if (conf.solo) {
        // show only the first image, hide the rest
        cards.forEach(function (card, i) {
          card.style.opacity = i === 0 ? '' : '0';
          card.style.willChange = '';
        });
      } else {
        show(cards);
      }
      return;
    }

    hide(cards);

    if (!('IntersectionObserver' in window)) {
      play(section);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: conf.threshold, rootMargin: conf.rootMargin }
    );

    io.observe(section);
  }

  function teardown(section) {
    if (section.__oathStackStartTimer) {
      window.clearTimeout(section.__oathStackStartTimer);
      section.__oathStackStartTimer = null;
    }
    if (typeof section.__oathStackStop === 'function') {
      section.__oathStackStop();
      section.__oathStackStop = null;
    }
  }

  function initAll(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll(SECTION_SELECTOR), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    var section =
      (target.matches && target.matches(SECTION_SELECTOR) && target) ||
      target.querySelector(SECTION_SELECTOR);
    if (!section) return;
    teardown(section);
    section.dataset.oathStackInit = '';
    section.dataset.oathStackDone = '';
    section.__oathStackCfg = null;
    init(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var target = e.target;
    var section =
      (target.matches && target.matches(SECTION_SELECTOR) && target) ||
      target.querySelector(SECTION_SELECTOR);
    if (section) teardown(section);
  });
})();